import Lottie from "lottie-react"

import loading from "@/assets/lottie/loader.json"
import { Colors } from "@/modules/helpers/const"
export const TagIcon = ({ color = "#1C274C" }) => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M4.72848 16.1369C3.18295 14.5914 2.41018 13.8186 2.12264 12.816C1.83509 11.8134 2.08083 10.7485 2.57231 8.61875L2.85574 7.39057C3.26922 5.59881 3.47597 4.70292 4.08944 4.08944C4.70292 3.47597 5.59881 3.26922 7.39057 2.85574L8.61875 2.57231C10.7485 2.08083 11.8134 1.83509 12.816 2.12264C13.8186 2.41018 14.5914 3.18295 16.1369 4.72848L17.9665 6.55812C20.6555 9.24711 22 10.5916 22 12.2623C22 13.933 20.6555 15.2775 17.9665 17.9665C15.2775 20.6555 13.933 22 12.2623 22C10.5916 22 9.24711 20.6555 6.55812 17.9665L4.72848 16.1369Z"
        stroke={color}
        strokeWidth="1.5"
      ></path>{" "}
      <circle
        opacity="0.5"
        cx="8.60699"
        cy="8.87891"
        r="2"
        transform="rotate(-45 8.60699 8.87891)"
        stroke={color}
        strokeWidth="1.5"
      ></circle>{" "}
      <path
        opacity="0.5"
        d="M11.5417 18.5L18.5208 11.5208"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>{" "}
    </g>
  </svg>
)

export const ReportIcon = ({ color = "black" }: { color?: string }) => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M6 14.4623H16.1909C17.6066 14.4623 18.472 12.7739 17.7261 11.4671L17.2365 10.6092C16.7547 9.76504 16.7547 8.69728 17.2365 7.85309L17.7261 6.99524C18.472 5.68842 17.6066 4 16.1909 4L6 4L6 14.4623ZM6 14.4623L6 20"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>{" "}
    </g>
  </svg>
)

export const TikTokIcon = () => (
  <div className="w-5 h-5 flex bg-black rounded-sm items-center justify-center">
    <svg
      viewBox="-72.5 -72.5 395.00 395.00"
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
    >
      <g id="SVGRepo_iconCarrier">
        <g clipRule="evenodd" fillRule="evenodd">
          <path
            d="M161.167 81.186c10.944 7.819 24.352 12.42 38.832 12.42V65.755a39.26 39.26 0 0 1-8.155-.853v21.923c-14.479 0-27.885-4.601-38.832-12.42v56.835c0 28.432-23.06 51.479-51.505 51.479-10.613 0-20.478-3.207-28.673-8.707C82.187 183.57 95.23 189.5 109.66 189.5c28.447 0 51.508-23.047 51.508-51.48V81.186zm10.06-28.098c-5.593-6.107-9.265-14-10.06-22.726V26.78h-7.728c1.945 11.09 8.58 20.565 17.788 26.308zm-80.402 99.107a23.445 23.445 0 0 1-4.806-14.256c0-13.004 10.548-23.547 23.561-23.547a23.6 23.6 0 0 1 7.147 1.103V87.022a51.97 51.97 0 0 0-8.152-.469v22.162a23.619 23.619 0 0 0-7.15-1.103c-13.013 0-23.56 10.543-23.56 23.548 0 9.195 5.272 17.157 12.96 21.035z"
            fill="#ee1d52"
          />
          <path
            d="M153.012 74.405c10.947 7.819 24.353 12.42 38.832 12.42V64.902c-8.082-1.72-15.237-5.942-20.617-11.814-9.208-5.743-15.843-15.218-17.788-26.308H133.14v111.239c-.046 12.968-10.576 23.468-23.561 23.468-7.652 0-14.45-3.645-18.755-9.292-7.688-3.878-12.96-11.84-12.96-21.035 0-13.005 10.547-23.548 23.56-23.548 2.493 0 4.896.388 7.15 1.103V86.553c-27.945.577-50.42 23.399-50.42 51.467 0 14.011 5.597 26.713 14.68 35.993 8.195 5.5 18.06 8.707 28.673 8.707 28.445 0 51.505-23.048 51.505-51.479z"
            fill="#ffffff"
          />
          <path
            d="M191.844 64.902v-5.928a38.84 38.84 0 0 1-20.617-5.887 38.948 38.948 0 0 0 20.617 11.815zM153.439 26.78a39.524 39.524 0 0 1-.427-3.198V20h-28.028v111.24c-.045 12.967-10.574 23.467-23.56 23.467-3.813 0-7.412-.904-10.6-2.512 4.305 5.647 11.103 9.292 18.755 9.292 12.984 0 23.515-10.5 23.561-23.468V26.78zm-44.864 59.773v-6.311a51.97 51.97 0 0 0-7.067-.479C73.06 79.763 50 102.811 50 131.24c0 17.824 9.063 33.532 22.835 42.772-9.083-9.28-14.68-21.982-14.68-35.993 0-28.067 22.474-50.889 50.42-51.466z"
            fill="#69c9d0"
          />
        </g>
      </g>
    </svg>
  </div>
)
export const PricingIcon = () => (
  <svg
    width={16}
    height={16}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 392.598 392.598"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        style={{ fill: "#FFFFFF" }}
        d="M359.855,260.331h-76.606l-18.554,26.764c-2.004,2.909-5.43,4.719-8.986,4.719h-118.82 c-3.556,0-6.982-1.745-8.986-4.719l-18.554-26.764H32.743c-6.012,0-10.925,4.848-10.925,10.925v88.63 c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.848,10.925-10.925v-88.695 C370.78,265.18,365.867,260.331,359.855,260.331z"
      />

      <g>
        <path
          style={{ fill: "#194F82" }}
          d="M71.919,21.851h248.824c6.012,0,10.925-4.848,10.925-10.925S326.82,0,320.743,0H71.919 c-6.012,0-10.925,4.848-10.925,10.925S65.842,21.851,71.919,21.851z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M128.937,116.816c7.37,0,13.382,5.947,13.382,13.382c0,6.012,4.848,10.925,10.925,10.925 c6.077,0,10.925-4.848,10.925-10.925c0-15.515-10.214-28.832-24.242-33.358v-5.56c0-6.012-4.848-10.925-10.925-10.925 c-6.012,0-10.925,4.848-10.925,10.925v5.56c-14.093,4.655-24.242,17.842-24.242,33.358c0,19.394,15.774,35.168,35.168,35.168h0.065 c6.723,0.711,13.317,6.271,13.317,13.188c0,7.37-5.947,13.382-13.382,13.382c-7.37,0-13.382-5.947-13.382-13.382 c0-6.012-4.848-10.925-10.925-10.925c-6.077,0-10.925,4.848-10.925,10.925c0,15.515,10.214,28.832,24.242,33.358v5.56 c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925v-5.56c14.093-4.655,24.242-17.842,24.242-33.358 c0-19.394-17.067-35.103-36.461-35.103h-0.065c-6.723-0.711-11.96-6.335-11.96-13.317 C115.556,122.828,121.503,116.816,128.937,116.816z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M203.281,123.604h84.687c6.012,0,10.925-4.848,10.925-10.925s-4.848-10.925-10.925-10.925h-84.687 c-6.012,0-10.925,4.848-10.925,10.925S197.204,123.604,203.281,123.604z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M287.968,146.877h-84.687c-6.012,0-10.925,4.848-10.925,10.925s4.848,10.925,10.925,10.925h84.687 c6.012,0,10.925-4.848,10.925-10.925S293.98,146.877,287.968,146.877z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M287.968,191.935h-84.687c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h84.687c6.012,0,10.925-4.848,10.925-10.925C298.828,196.784,293.98,191.935,287.968,191.935z"
        />
      </g>

      <path
        style={{ fill: "#56ACE0" }}
        d="M124.024,243.135l18.554,26.764h107.313l18.554-26.764c2.004-2.909,5.43-4.719,8.986-4.719h60.251 V70.271H54.917v168.145h60.186C118.659,238.545,122.02,240.226,124.024,243.135z M203.281,101.818h84.687 c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925h-84.687c-6.012,0-10.925-4.848-10.925-10.925 C192.356,106.667,197.204,101.818,203.281,101.818z M203.281,146.877h84.687c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925h-84.687c-6.012,0-10.925-4.848-10.925-10.925S197.204,146.877,203.281,146.877z M203.281,191.935h84.687c6.012,0,10.925,4.848,10.925,10.925s-4.848,10.925-10.925,10.925h-84.687 c-6.012,0-10.925-4.848-10.925-10.925S197.204,191.935,203.281,191.935z M93.77,178.618c0-6.012,4.848-10.925,10.925-10.925 c6.077,0,10.925,4.848,10.925,10.925c0,7.37,5.947,13.382,13.382,13.382c7.37,0,13.382-5.947,13.382-13.382 c0-6.853-6.594-12.541-13.317-13.188c-0.065,0-0.323,0-0.065,0c-19.394,0-35.168-15.774-35.168-35.168 c0-15.515,10.214-28.832,24.242-33.358v-5.56c0-6.012,4.848-10.925,10.925-10.925s10.925,4.848,10.925,10.925v5.56 c14.093,4.655,24.242,17.842,24.242,33.358c0,6.012-4.848,10.925-10.925,10.925c-6.077,0-10.925-4.848-10.925-10.925 c0-7.37-5.947-13.382-13.382-13.382c-7.37,0-13.382,5.947-13.382,13.382c0,6.853,5.236,12.606,11.96,13.317c0.065,0,0.323,0,0.065,0 c19.394,0,36.461,15.709,36.461,35.103c0,15.515-10.214,28.832-24.242,33.358v5.56c0,6.012-4.848,10.925-10.925,10.925 c-6.077,0-10.925-4.848-10.925-10.925v-5.56C103.984,207.386,93.77,194.198,93.77,178.618z"
      />

      <path
        style={{ fill: "#194F82" }}
        d="M359.855,238.545h-0.388V59.41c0-6.012-4.848-10.925-10.925-10.925H43.992 c-6.012,0-10.925,4.848-10.925,10.925v179.135h-0.323c-18.036,0-32.711,14.675-32.711,32.711v88.63 c0,18.036,14.675,32.711,32.711,32.711h327.111c18.036,0,32.711-14.675,32.711-32.711v-88.695 C392.566,253.22,377.891,238.545,359.855,238.545z M54.917,70.271h282.828v168.145H277.56c-3.556,0-6.982,1.745-8.986,4.719 l-18.554,26.764H142.578l-18.554-26.764c-2.004-2.909-5.43-4.719-8.986-4.719H54.917V70.271z M370.78,359.887 c0,6.012-4.848,10.925-10.925,10.925H32.743c-6.012,0-10.925-4.848-10.925-10.925v-88.695c0-6.012,4.848-10.925,10.925-10.925 h76.671l18.554,26.764c2.004,2.909,5.43,4.719,8.986,4.719h118.756c3.556,0,6.853-1.745,8.986-4.719l18.554-26.764h76.671 c6.012,0,10.925,4.848,10.925,10.925v88.695H370.78z"
      />

      <path
        style={{ fill: "#FFC10D" }}
        d="M359.855,260.331h-76.606l-18.554,26.764c-2.004,2.909-5.43,4.719-8.986,4.719h-118.82 c-3.556,0-6.982-1.745-8.986-4.719l-18.554-26.764H32.743c-6.012,0-10.925,4.848-10.925,10.925v14.933h45.576 c5.947,0,10.796,4.848,10.796,10.796l0,0c0,5.947-4.848,10.796-10.796,10.796H21.818v19.329h22.174 c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H21.818v10.925c0,6.012,4.848,10.925,10.925,10.925h327.111 c6.012,0,10.925-4.848,10.925-10.925v-88.695C370.78,265.18,365.867,260.331,359.855,260.331z"
      />
    </g>
  </svg>
)

export const SocialIcon = () => (
  <svg
    width={16}
    height={16}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 392.598 392.598"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        style={{ fill: "#FFFFFF" }}
        d="M222.869,32.711c0-6.012-4.848-10.925-10.925-10.925h-179.2c-6.012,0-10.925,4.848-10.925,10.925 v327.111c0,6.012,4.848,10.925,10.925,10.925h179.2c6.012,0,10.925-4.848,10.925-10.925"
      />
      <path
        style={{ fill: "#56ACE0" }}
        d="M43.604,43.507V308.17h157.414v-31.935h-83.2c-18.036,0-32.711-14.675-32.711-32.711V87.855 c0-18.036,14.675-32.711,32.711-32.711h83.329V43.507C201.147,43.507,43.604,43.507,43.604,43.507z"
      />
      <path
        style={{ fill: "#FFC10D" }}
        d="M359.855,76.929H117.818c-6.012,0-10.925,4.848-10.925,10.925v155.733 c0,6.012,4.848,10.925,10.925,10.925h242.036c6.012,0,10.925-4.848,10.925-10.925V87.855 C370.78,81.842,365.867,76.929,359.855,76.929z"
      />
      <g>
        <path
          style={{ fill: "#194F82" }}
          d="M68.493,353.228H55.37c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h13.059c6.012,0,10.925,4.848,10.925,10.925C79.354,348.315,74.505,353.228,68.493,353.228z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M128.937,353.228h-13.059c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h13.059c6.012,0,10.925,4.848,10.925,10.925C139.798,348.315,134.95,353.228,128.937,353.228z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M189.317,353.228h-13.123c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h13.123c6.012,0,10.925,4.848,10.925,10.925C200.242,348.315,195.394,353.228,189.317,353.228z"
        />
      </g>
      <rect x="161.455" y="130.069" style={{ fill: "#56ACE0" }} width="28.574" height="28.574" />
      <g>
        <path
          style={{ fill: "#194F82" }}
          d="M200.954,108.283h-50.489c-6.012,0-10.925,4.848-10.925,10.925v50.489 c0,6.012,4.848,10.925,10.925,10.925h50.489c6.012,0,10.925-4.848,10.925-10.925v-50.489 C211.814,113.131,206.966,108.283,200.954,108.283z M190.028,158.707h-28.574v-28.574h28.574V158.707z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M175.741,229.56h-25.212c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h25.212c6.012,0,10.925,4.848,10.925,10.925C186.667,224.711,181.754,229.56,175.741,229.56z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M251.378,229.56h-25.212c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h25.212c6.012,0,10.925,4.848,10.925,10.925C262.303,224.711,257.39,229.56,251.378,229.56z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M327.143,229.56h-25.212c-6.012,0-10.925-4.848-10.925-10.925c0-6.012,4.848-10.925,10.925-10.925 h25.212c6.012,0,10.925,4.848,10.925,10.925C338.004,224.711,333.156,229.56,327.143,229.56z"
        />
        <path
          style={{ fill: "#194F82" }}
          d="M359.855,55.079h-115.2V32.711C244.655,14.675,229.98,0,211.943,0h-179.2 C14.707,0,0.032,14.675,0.032,32.711v327.111c0,18.101,14.675,32.776,32.711,32.776h179.2c18.036,0,32.711-14.675,32.711-32.711 v-83.653h115.2c18.036,0,32.711-14.675,32.711-32.711V87.855C392.566,69.754,377.891,55.079,359.855,55.079z M222.869,359.822 c0,6.012-4.848,10.925-10.925,10.925h-179.2c-6.012,0-10.925-4.848-10.925-10.925V32.711c0-6.012,4.848-10.925,10.925-10.925h179.2 c6.012,0,10.925,4.848,10.925,10.925v22.432h-105.18c-18.036,0-32.711,14.675-32.711,32.711v155.604 c0,18.036,14.675,32.711,32.711,32.711h105.115v83.653H222.869z M370.78,243.588c0,6.012-4.848,10.925-10.925,10.925H117.818 c-6.012,0-10.925-4.848-10.925-10.925V87.855c0-6.012,4.848-10.925,10.925-10.925h242.036c6.012,0,10.925,4.848,10.925,10.925 V243.588z"
        />
      </g>
    </g>
  </svg>
)

export const ProfileIcon = () => (
  <svg
    width={16}
    height={16}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 392.533 392.533"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        style={{ fill: "#FFC10D" }}
        d="M196.267,207.063c21.721,0,39.434-17.713,39.434-39.434s-17.713-39.434-39.434-39.434 s-39.434,17.713-39.434,39.434C156.832,189.479,174.546,207.063,196.267,207.063z"
      />

      <path
        style={{ fill: "#56ACE0" }}
        d="M234.085,288.065l-28.38,49.713c-4.202,7.37-14.739,7.37-18.941,0l-28.38-49.713 c-34.715,13.899-58.57,45.576-62.513,82.683h200.598C292.655,333.64,268.735,301.964,234.085,288.065z"
      />

      <g>
        <path
          style={{ fill: "#194F82" }}
          d="M314.958,49.196C283.281,17.455,241.131,0,196.267,0S109.253,17.455,77.641,49.067 c-31.677,31.677-49.067,73.826-49.067,118.626c-0.065,44.865,17.39,87.014,49.067,118.691c4.267,4.267,11.119,4.267,15.451,0 c4.267-4.267,4.267-11.119,0-15.451C65.487,243.394,50.36,206.804,50.36,167.758c0-41.891,17.455-81.002,48.808-109.123 c54.756-48.937,139.313-48.937,194.133,0.065c31.354,28.057,48.808,67.168,48.808,109.059c0,39.046-15.127,75.701-42.667,103.24 c-4.267,4.267-4.267,11.119,0,15.451c4.267,4.267,11.119,4.267,15.451,0c31.677-31.612,49.067-73.826,49.067-118.626 S346.57,80.808,314.958,49.196z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M282.182,81.907c-54.949-54.949-149.85-46.222-192,26.246 c-27.345,47.063-18.295,106.861,20.17,145.325c4.267,4.267,11.119,4.267,15.451,0c4.267-4.267,4.267-11.119,0-15.451 c-38.853-38.853-38.853-102.077,0-140.929s102.077-38.853,140.865,0c18.747,18.747,29.156,43.83,29.156,70.465 s-10.343,51.717-29.156,70.465c-4.202,4.331-4.202,11.313,0.065,15.515c4.267,4.202,11.119,4.267,15.451,0 c22.885-22.885,35.556-53.398,35.556-85.851S305.131,104.792,282.182,81.907z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M196.267,106.473c-33.745,0-61.22,27.41-61.22,61.22c0,33.745,27.41,61.22,61.22,61.22 s61.22-27.41,61.22-61.22S230.012,106.473,196.267,106.473z M196.267,207.192c-21.721,0-39.434-17.713-39.434-39.434 c0-21.786,17.713-39.434,39.434-39.434s39.434,17.713,39.434,39.434S217.988,207.192,196.267,207.192z"
        />

        <path
          style={{ fill: "#194F82" }}
          d="M232.275,264.339c-4.848-1.487-10.15,0.646-12.671,5.042l-23.337,40.921l-23.337-40.986 c-2.521-4.396-7.822-6.465-12.671-5.042l0,0c-51.523,15.838-86.691,63.354-86.691,117.269v0.065 c0,6.012,4.848,10.925,10.925,10.925h223.612c6.012,0,10.925-4.848,10.925-10.925l0,0 C318.966,327.693,283.798,280.113,232.275,264.339z M95.935,370.747c3.943-37.107,27.798-68.784,62.513-82.683l28.38,49.713 c4.202,7.37,14.739,7.37,18.941,0l28.38-49.713c34.715,13.899,58.57,45.576,62.513,82.683H95.935z"
        />
      </g>
    </g>
  </svg>
)

export const NextIcon = () => (
  <svg
    width={14}
    height={14}
    fill="#000"
    className="mt-2"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    stroke="#000"
  >
    <g id="SVGRepo_iconCarrier">
      <g>
        <g>
          <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.616,256-256S397.385,0,256,0z M346.899,280.959 l-85.594,85.594c-13.783,13.784-36.132,13.784-49.917,0c-13.784-13.784-13.784-36.133,0-49.917L272.023,256l-60.635-60.635 c-13.784-13.784-13.784-36.133,0-49.917s36.134-13.784,49.917,0l85.594,85.594C360.683,244.825,360.683,267.175,346.899,280.959z" />
        </g>
      </g>
    </g>
  </svg>
)

// SVG Icon Components
export const FireIcon: React.FC = () => (
  <svg
    width={16}
    height={16}
    viewBox="-33 0 255 255"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid"
    fill="#000000"
  >
    <g id="SVGRepo_iconCarrier">
      <defs>
        <style
          dangerouslySetInnerHTML={{
            __html:
              " .cls-3 { fill: url(#linear-gradient-1); } .cls-4 { fill: #fc9502; } .cls-5 { fill: #fce202; } "
          }}
        />
        <linearGradient
          id="linear-gradient-1"
          gradientUnits="userSpaceOnUse"
          x1="94.141"
          y1={255}
          x2="94.141"
          y2="0.188"
        >
          <stop offset={0} stopColor="#ff4c0d" />
          <stop offset={1} stopColor="#fc9502" />
        </linearGradient>
      </defs>
      <g id="fire">
        <path
          d="M187.899,164.809 C185.803,214.868 144.574,254.812 94.000,254.812 C42.085,254.812 -0.000,211.312 -0.000,160.812 C-0.000,154.062 -0.121,140.572 10.000,117.812 C16.057,104.191 19.856,95.634 22.000,87.812 C23.178,83.513 25.469,76.683 32.000,87.812 C35.851,94.374 36.000,103.812 36.000,103.812 C36.000,103.812 50.328,92.817 60.000,71.812 C74.179,41.019 62.866,22.612 59.000,9.812 C57.662,5.384 56.822,-2.574 66.000,0.812 C75.352,4.263 100.076,21.570 113.000,39.812 C131.445,65.847 138.000,90.812 138.000,90.812 C138.000,90.812 143.906,83.482 146.000,75.812 C148.365,67.151 148.400,58.573 155.999,67.813 C163.226,76.600 173.959,93.113 180.000,108.812 C190.969,137.321 187.899,164.809 187.899,164.809 Z"
          id="path-1"
          className="cls-3"
          fillRule="evenodd"
        />
        <path
          d="M94.000,254.812 C58.101,254.812 29.000,225.711 29.000,189.812 C29.000,168.151 37.729,155.000 55.896,137.166 C67.528,125.747 78.415,111.722 83.042,102.172 C83.953,100.292 86.026,90.495 94.019,101.966 C98.212,107.982 104.785,118.681 109.000,127.812 C116.266,143.555 118.000,158.812 118.000,158.812 C118.000,158.812 125.121,154.616 130.000,143.812 C131.573,140.330 134.753,127.148 143.643,140.328 C150.166,150.000 159.127,167.390 159.000,189.812 C159.000,225.711 129.898,254.812 94.000,254.812 Z"
          id="path-2"
          className="cls-4"
          fillRule="evenodd"
        />
        <path
          d="M95.000,183.812 C104.250,183.812 104.250,200.941 116.000,223.812 C123.824,239.041 112.121,254.812 95.000,254.812 C77.879,254.812 69.000,240.933 69.000,223.812 C69.000,206.692 85.750,183.812 95.000,183.812 Z"
          id="path-3"
          className="cls-5"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
)

export const EasySellIcon: React.FC = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path d="M566 268.4v66.3H353.9v-66.3h-66.3v-79.5h357.9v79.5H566z" fill="#FFFFFF" />
      <path
        d="M558.5 319.2l98.7 86.4c72.6 50.6 115.8 133.5 115.8 222 0 88-63.7 163-150.5 177.4-55 9.1-110.1 13.6-165.1 13.6s-110.1-4.5-165.1-13.6c-86.8-14.3-150.5-89.4-150.5-177.4 0-88.5 43.3-171.3 115.8-221.9l113.7-86.4h187.2z"
        fill="#FFFFFF"
      />
      <path
        d="M457.4 845.1c-56.2 0-113.2-4.7-169.4-14C188 814.6 115.3 729 115.3 627.6c0-97.1 47.5-188.2 127.2-243.7l119.9-91.2h206l105.1 92c78.9 55.6 126 146.2 126 242.8 0 101.4-72.6 187-172.7 203.5-56.1 9.4-113.1 14.1-169.4 14.1z m-77.2-499.4l-106.5 81c-66.3 46.2-105.4 121.1-105.4 200.8 0 75.3 54 138.9 128.3 151.2 106.7 17.6 214.9 17.6 321.6 0 74.3-12.3 128.3-75.9 128.3-151.2 0-79.7-39.1-154.6-104.5-200.2l-2.3-1.8-91.2-79.8H380.2z"
        fill="#333333"
      />
      <path
        d="M354 305l-66.7-57.3c-13.8-8.9-21-22.7-20.7-36.7m395.1 0.1c0 14.7-8.3 28.4-22.1 36.5L561.9 308"
        fill="#FFFFFF"
      />
      <path
        d="M561.9 334.5c-7.9 0-15.7-3.5-21-10.3-9-11.6-6.9-28.2 4.7-37.2l80.5-62.2c5.7-3.3 9-8.5 9-13.7 0-14.6 11.9-26.5 26.5-26.5s26.5 11.9 26.5 26.5c0 23.6-12.5 45.3-33.6 58.4l-76.6 59.4c-4.6 3.8-10.3 5.6-16 5.6z m-208-3c-6.1 0-12.3-2.1-17.3-6.4l-65.4-56.3c-20-13.6-31.6-35.3-31.2-58.4 0.3-14.6 12.8-26.4 27-26 14.6 0.3 26.3 12.4 26 27-0.1 5.3 3 10.4 8.5 13.9l2.9 2.2 66.7 57.3c11.1 9.5 12.4 26.3 2.8 37.4-5.1 6.2-12.5 9.3-20 9.3z"
        fill="#333333"
      />
      <path
        d="M365.4 229.3c-14.6 0-26.5-11.9-26.5-26.5 0-6.6-9.8-13.9-22.9-13.9s-22.9 7.4-22.9 13.9c0 14.6-11.9 26.5-26.5 26.5s-26.5-11.9-26.5-26.5c0-36.9 34-67 75.9-67s75.9 30 75.9 67c0 14.7-11.9 26.5-26.5 26.5zM562.9 229.3c-14.6 0-26.5-11.9-26.5-26.5 0-6.6-9.8-13.9-22.9-13.9-13.1 0-22.9 7.4-22.9 13.9 0 14.6-11.9 26.5-26.5 26.5s-26.5-11.9-26.5-26.5c0-36.9 34.1-67 75.9-67s75.9 30 75.9 67c0.1 14.7-11.8 26.5-26.5 26.5z"
        fill="#333333"
      />
      <path
        d="M661.7 229.3c-14.6 0-26.5-11.9-26.5-26.5 0-6.6-9.8-13.9-22.9-13.9s-22.9 7.4-22.9 13.9c0 14.6-11.9 26.5-26.5 26.5s-26.5-11.8-26.5-26.5c0-36.9 34-67 75.9-67s75.9 30 75.9 67c0 14.7-11.8 26.5-26.5 26.5zM464.2 229.3c-14.6 0-26.5-11.9-26.5-26.5 0-6.6-9.8-13.9-22.9-13.9s-22.9 7.4-22.9 13.9c0 14.6-11.9 26.5-26.5 26.5s-26.5-11.9-26.5-26.5c0-36.9 34-67 75.9-67s75.9 30 75.9 67c0 14.7-11.9 26.5-26.5 26.5z"
        fill="#333333"
      />
      <path
        d="M679.1 621.5m-205.1 0a205.1 205.1 0 1 0 410.2 0 205.1 205.1 0 1 0-410.2 0Z"
        fill="#FFDB5B"
      />
      <path
        d="M679.1 853.1c-127.7 0-231.6-103.9-231.6-231.6 0-127.7 103.9-231.6 231.6-231.6s231.6 103.9 231.6 231.6c0 127.7-103.9 231.6-231.6 231.6z m0-410.2C580.6 442.9 500.4 523 500.4 621.5S580.5 800.1 679 800.1 857.7 720 857.7 621.5s-80.2-178.6-178.6-178.6z"
        fill="#333333"
      />
      <path d="M720.47 621.453l-41.436 41.436-41.437-41.436 41.436-41.437z" fill="#FFFFFF" />
      <path
        d="M679.079 737.919l-116.46-116.46 116.46-116.461 116.46 116.46-116.46 116.46z m-41.508-116.46l41.437 41.436 41.436-41.437-41.436-41.436-41.437 41.436z"
        fill="#333333"
      />
      <path
        d="M591.6 302.3l76-20.4c14.1-3.8 28.7 4.6 32.5 18.7 3.8 14.1-4.6 28.7-18.7 32.5l-76 20.4c-14.1 3.8-28.7-4.6-32.5-18.7-3.8-14.2 4.6-28.7 18.7-32.5z"
        fill="#333333"
      />
    </g>
  </svg>
)

export const SuitableIcon: React.FC = () => (
  <svg
    viewBox="0 0 1024 1024"
    width={20}
    height={20}
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        d="M804.6 473.9v292.6c0 21.9-17.8 39.7-39.7 39.7H259.7c-21.9 0-39.7-17.8-39.7-39.7V473.9h-18.8c-21.9 0-39.7-17.8-39.7-39.7v-68.3c0-21.9 17.8-39.7 39.7-39.7h622.1c21.9 0 39.7 17.8 39.7 39.7v68.3c0 21.9-17.8 39.7-39.7 39.7h-18.7z"
        fill="#FFFFFF"
      />
      <path
        d="M764.9 832.7H259.7c-36.5 0-66.2-29.7-66.2-66.2V499.9c-32.9-3.8-58.5-31.9-58.5-65.7v-68.3c0-36.5 29.7-66.2 66.2-66.2h622.1c36.5 0 66.2 29.7 66.2 66.2v68.3c0 33.9-25.6 61.9-58.5 65.7v266.6c0.1 36.5-29.6 66.2-66.1 66.2z m-563.7-480c-7.3 0-13.2 5.9-13.2 13.2v68.3c0 7.3 5.9 13.2 13.2 13.2h45.2v319.1c0 7.3 5.9 13.2 13.2 13.2h505.3c7.3 0 13.2-5.9 13.2-13.2V447.4h45.2c7.3 0 13.2-5.9 13.2-13.2v-68.3c0-7.3-5.9-13.2-13.2-13.2H201.2z"
        fill="#333333"
      />
      <path d="M473.3 492.3h78v295.4h-78z" fill="#FFDB5B" />
      <path d="M239.5 447.4h545.6v51.7H239.5z" fill="#333333" />
      <path
        d="M305.751 228.226l19.659-11.35c15.502-8.95 35.246-3.952 44.665 11.163l41.115 66.213-104.068 2.35-13.486-23.16c-9.237-15.799-3.82-36.016 11.979-45.252 0.05 0.086 0.05 0.086 0.136 0.036z"
        fill="#FFDB5B"
      />
      <path
        d="M277.11 350.417l-29.174-50.129c-23.786-41-9.93-93.801 31.069-117.588l0.26-0.15 19.658-11.35c40.444-23.35 91.48-10.553 116.078 29.053l90.15 144.944-228.041 5.22z m28.641-122.19l-0.346 0.2c-15.539 9.086-20.906 29.39-11.806 45.151l13.437 23.073 104.154-2.399-41.115-66.213c-9.52-15.288-29.163-20.113-44.665-11.163l-19.659 11.35zM414.8 492.3h58.5v295.4h-58.5zM551.3 492.3h58.5v295.4h-58.5z"
        fill="#333333"
      />
      <path
        d="M716.76 228.266l-19.66-11.35c-15.501-8.95-35.245-3.952-44.665 11.163l-41.115 66.213 104.068 2.349 13.437-23.073c9.237-15.798 3.82-36.015-11.979-45.252l-0.086-0.05z"
        fill="#FFDB5B"
      />
      <path
        d="M745.364 350.32l-228.041-5.22 90.15-144.943c24.649-39.694 75.634-52.404 116.078-29.054l20.611 11.9c19.509 11.61 33.455 30.054 39.262 51.997 5.88 22.217 2.787 45.373-8.8 65.241l-29.26 50.08zM611.27 294.38l104.068 2.349 13.487-23.16c4.4-7.62 5.655-16.596 3.386-25.065-2.22-8.556-7.707-15.65-15.278-20.137l-19.832-11.45c-15.589-9-35.196-4.039-44.666 11.163l-41.165 66.3z"
        fill="#333333"
      />
    </g>
  </svg>
)

export const FilterIcon: React.FC = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M3 4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H19.4C19.9601 3 20.2401 3 20.454 3.10899C20.6422 3.20487 20.7951 3.35785 20.891 3.54601C21 3.75992 21 4.03995 21 4.6V6.33726C21 6.58185 21 6.70414 20.9724 6.81923C20.9479 6.92127 20.9075 7.01881 20.8526 7.10828C20.7908 7.2092 20.7043 7.29568 20.5314 7.46863L14.4686 13.5314C14.2957 13.7043 14.2092 13.7908 14.1474 13.8917C14.0925 13.9812 14.0521 14.0787 14.0276 14.1808C14 14.2959 14 14.4182 14 14.6627V17L10 21V14.6627C10 14.4182 10 14.2959 9.97237 14.1808C9.94787 14.0787 9.90747 13.9812 9.85264 13.8917C9.7908 13.7908 9.70432 13.7043 9.53137 13.5314L3.46863 7.46863C3.29568 7.29568 3.2092 7.2092 3.14736 7.10828C3.09253 7.01881 3.05213 6.92127 3.02763 6.81923C3 6.70414 3 6.58185 3 6.33726V4.6Z"
        stroke="#000000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export const LoadingSpinner: React.FC<{ className: string }> = ({ className }) => (
  <div className="flex items-center justify-center h-full">
    <Lottie animationData={loading} loop={true} className={className} />
  </div>
)

// Saved/Bookmark Icon
export const SavedIcon: React.FC<{ size?: number; color?: string }> = ({ size = 18, color }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M45.35 6.1709H19.41C16.8178 6.17618 14.3333 7.20827 12.5003 9.04123C10.6674 10.8742 9.63528 13.3587 9.62999 15.9509V52.2709C9.6272 53.3655 9.92973 54.4392 10.5036 55.3713C11.0775 56.3034 11.9 57.057 12.8787 57.5474C13.8573 58.0377 14.9533 58.2454 16.0435 58.1471C17.1337 58.0488 18.1748 57.6484 19.05 56.9909L31.25 47.8509C31.5783 47.6074 31.9762 47.4759 32.385 47.4759C32.7938 47.4759 33.1917 47.6074 33.52 47.8509L45.71 56.9809C46.5842 57.6387 47.6246 58.0397 48.7142 58.1387C49.8038 58.2378 50.8994 58.0311 51.8779 57.5418C52.8565 57.0525 53.6793 56.3001 54.2537 55.3689C54.8282 54.4378 55.1317 53.365 55.13 52.2709V15.9509C55.1247 13.3587 54.0926 10.8742 52.2597 9.04123C50.4267 7.20827 47.9422 6.17618 45.35 6.1709Z"
          fill={color || Colors.accent[1]}
        />
      </g>
    </svg>
  )
}

export const BookmarkIcon: React.FC<{ saved: boolean; size?: number }> = ({ saved, size = 30 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M45.35 6.1709H19.41C16.8178 6.17618 14.3333 7.20827 12.5003 9.04123C10.6674 10.8742 9.63528 13.3587 9.62999 15.9509V52.2709C9.6272 53.3655 9.92973 54.4392 10.5036 55.3713C11.0775 56.3034 11.9 57.057 12.8787 57.5474C13.8573 58.0377 14.9533 58.2454 16.0435 58.1471C17.1337 58.0488 18.1748 57.6484 19.05 56.9909L31.25 47.8509C31.5783 47.6074 31.9762 47.4759 32.385 47.4759C32.7938 47.4759 33.1917 47.6074 33.52 47.8509L45.71 56.9809C46.5842 57.6387 47.6246 58.0397 48.7142 58.1387C49.8038 58.2378 50.8994 58.0311 51.8779 57.5418C52.8565 57.0525 53.6793 56.3001 54.2537 55.3689C54.8282 54.4378 55.1317 53.365 55.13 52.2709V15.9509C55.1247 13.3587 54.0926 10.8742 52.2597 9.04123C50.4267 7.20827 47.9422 6.17618 45.35 6.1709Z"
          fill={saved ? Colors.accent[1] : Colors.grey[3]}
        />
      </g>
    </svg>
  )
}

// Campaign Icon
export const CampaignIcon: React.FC<{ size?: number; color?: string }> = ({ size = 24, color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.21695 2.75001H16.4629C16.5503 2.74971 16.6363 2.77119 16.7132 2.81252C16.7902 2.85384 16.8556 2.91371 16.9035 2.98669C16.9515 3.05967 16.9805 3.14346 16.9879 3.23047C16.9953 3.31749 16.9809 3.40497 16.9459 3.48501L14.1109 10.102H18.8899C18.93 10.1024 18.969 10.1143 19.0025 10.1361C19.0361 10.158 19.0626 10.189 19.0791 10.2254C19.0956 10.2619 19.1014 10.3023 19.0957 10.3419C19.09 10.3815 19.0731 10.4187 19.0469 10.449L9.30095 21.16C9.27435 21.1998 9.23438 21.2287 9.1883 21.2415C9.14221 21.2543 9.09305 21.2502 9.04975 21.2299C9.00645 21.2095 8.97186 21.1744 8.95226 21.1307C8.93267 21.0871 8.92936 21.0379 8.94295 20.992L9.90995 13.252H5.43595C5.34906 13.2532 5.26323 13.2328 5.18614 13.1927C5.10904 13.1526 5.04308 13.0941 4.99415 13.0222C4.94522 12.9504 4.91484 12.8676 4.90573 12.7812C4.89662 12.6948 4.90906 12.6074 4.94195 12.527L8.72195 3.07501C8.76202 2.97714 8.83072 2.89365 8.91904 2.83548C9.00737 2.77731 9.1112 2.74817 9.21695 2.75001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Camera Icon
export const CameraIcon: React.FC = () => (
  <svg width="14" height="12" viewBox="0 0 18 16">
    <path
      d="M9 12.8145C10.087 12.8145 11.0086 12.4389 11.7647 11.6878C12.5207 10.9367 12.8988 10.0211 12.8988 8.94118C12.8988 7.86124 12.5207 6.94571 11.7647 6.19458C11.0086 5.44346 10.087 5.0679 9 5.0679C7.91295 5.0679 6.9914 5.44346 6.23533 6.19458C5.47927 6.94571 5.10124 7.86124 5.10124 8.94118C5.10124 10.0211 5.47927 10.9367 6.23533 11.6878C6.9914 12.4389 7.91295 12.8145 9 12.8145ZM9 11.4027C8.3004 11.4027 7.71254 11.1662 7.23642 10.6932C6.7603 10.2202 6.52225 9.63621 6.52225 8.94118C6.52225 8.24615 6.7603 7.66213 7.23642 7.18913C7.71254 6.71612 8.3004 6.47962 9 6.47962C9.6996 6.47962 10.2875 6.71612 10.7636 7.18913C11.2397 7.66213 11.4778 8.24615 11.4778 8.94118C11.4778 9.63621 11.2397 10.2202 10.7636 10.6932C10.2875 11.1662 9.6996 11.4027 9 11.4027ZM1.71256 16C1.23401 16 0.828949 15.8353 0.49737 15.5059C0.16579 15.1765 0 14.7741 0 14.2986V3.58373C0 3.10831 0.16579 2.70589 0.49737 2.37648C0.828949 2.04706 1.23401 1.88236 1.71256 1.88236H4.60567L6.3583 0H11.6417L13.3943 1.88236H16.2874C16.766 1.88236 17.171 2.04706 17.5026 2.37648C17.8342 2.70589 18 3.10831 18 3.58373V14.2986C18 14.7741 17.8342 15.1765 17.5026 15.5059C17.171 15.8353 16.766 16 16.2874 16H1.71256ZM1.71256 14.5883H16.2874C16.3725 14.5883 16.4423 14.5611 16.497 14.5068C16.5516 14.4525 16.579 14.3831 16.579 14.2986V3.58373C16.579 3.49926 16.5516 3.42987 16.497 3.37556C16.4423 3.32126 16.3725 3.2941 16.2874 3.2941H12.7603L11.0223 1.41175H6.97772L5.23967 3.2941H1.71256C1.62754 3.2941 1.55769 3.32126 1.50303 3.37556C1.44836 3.42987 1.42103 3.49926 1.42103 3.58373V14.2986C1.42103 14.3831 1.44836 14.4525 1.50303 14.5068C1.55769 14.5611 1.62754 14.5883 1.71256 14.5883Z"
      fill="white"
    />
  </svg>
)

// Arrow Left Icon (with gradient)
export const ArrowLeftIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.1775 4.44751L2.625 9.00001L7.1775 13.5525"
      stroke="url(#paint0_linear_1015_5000)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3749 9H2.75244"
      stroke="url(#paint1_linear_1015_5000)"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1015_5000"
        x1="2.625"
        y1="9.0353"
        x2="7.1775"
        y2="9.03494"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0091AA" />
        <stop offset="1" stopColor="#57C785" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1015_5000"
        x1="2.75244"
        y1="9.50388"
        x2="15.3749"
        y2="9.47871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0091AA" />
        <stop offset="1" stopColor="#57C785" />
      </linearGradient>
    </defs>
  </svg>
)

// Hot/Fire Icon
export const HotIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.8877 1.35584C11.8877 4.31001 13.4452 5.79501 14.7868 7.20667C16.0702 8.55667 17.2918 9.84251 17.2918 12.2917C17.2918 16.3017 14.1643 19.1667 10.1543 19.1667C6.1435 19.1667 2.7085 16.3158 2.7085 12.2917C2.7085 10.5925 3.51016 8.94917 4.79933 8.20917C5.0535 8.06334 5.35933 8.21501 5.4685 8.48751C6.30266 10.57 7.331 10.5333 7.86433 10C8.18766 9.67751 8.256 9.07001 7.861 8.28167C5.85683 4.27167 9.4135 1.38251 11.361 0.903339C11.641 0.835005 11.8735 1.06834 11.8877 1.35584ZM10.1543 17.9167C13.5368 17.9167 16.0418 15.55 16.0418 12.2917C16.0418 10.3442 15.131 9.38417 13.8102 7.99334L13.7927 7.97417C12.5927 6.71001 11.1768 5.18167 10.7518 2.51001C10.1226 2.87992 9.57967 3.37996 9.15933 3.97667C8.5035 4.93001 8.2035 6.17084 8.97933 7.72251C9.48183 8.72667 9.62683 10.0058 8.7485 10.8842C8.201 11.4317 7.28016 11.8008 6.28516 11.3725C5.6585 11.1025 5.15766 10.5767 4.7535 9.88084C4.281 10.4692 3.9585 11.3308 3.9585 12.2917C3.9585 15.4975 6.6985 17.9167 10.1543 17.9167Z"
      fill="#E63535"
    />
  </svg>
)

// Share Icon
export const ShareIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size * 0.6}
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.3129 0.929311C6.18765 0.2176 6.98343 -0.276273 7.53634 0.170415L11.7084 3.54652C11.7993 3.62011 11.8727 3.71398 11.9233 3.82106C11.9738 3.92813 12 4.04561 12 4.16465C12 4.28368 11.9738 4.40117 11.9233 4.50824C11.8727 4.61531 11.7993 4.70918 11.7084 4.78278L7.53634 8.15888C6.98343 8.60557 6.18765 8.1117 6.3129 7.3992L6.5191 6.2353C4.87408 5.90028 3.72777 6.18575 2.92665 6.67412C2.06061 7.20338 1.55046 8.00081 1.26178 8.64174C1.1205 8.95631 0.796689 9.01687 0.604236 8.99642C0.414075 8.9744 0.0803379 8.83678 0.046735 8.45379C-0.207577 5.53381 0.593545 3.74313 2.02243 2.78998C3.27261 1.95638 4.91685 1.82898 6.50382 2.00907L6.3129 0.929311ZM11.2365 4.16465L7.06438 0.789328L7.34847 2.39835C7.35935 2.45987 7.35581 2.52318 7.33816 2.58302C7.32051 2.64286 7.28926 2.6975 7.247 2.7424C7.20473 2.78731 7.15267 2.82119 7.09515 2.84122C7.03762 2.86126 6.97628 2.86688 6.91622 2.85762C5.22997 2.59574 3.58725 2.68382 2.43712 3.45058C1.39467 4.14577 0.662278 5.46696 0.775305 7.897C1.12813 7.24978 1.68258 6.51998 2.53716 5.9978C3.59107 5.3545 5.05355 5.05724 7.0491 5.55032C7.14417 5.57365 7.22692 5.63362 7.28034 5.71789C7.33376 5.80215 7.35377 5.9043 7.33626 6.0033L7.06438 7.53997L11.2365 4.16465Z"
      fill="white"
    />
  </svg>
)

// Hidden Balance Icon
export const HiddenBalanceIcon: React.FC<{ size?: number }> = ({ size = 45 }) => (
  <svg width={size} height={size * 0.267} viewBox="0 0 45 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.50089 9.49999C2.04255 9.49999 1.62399 9.38825 1.24521 9.16476C0.866418 8.93749 0.563388 8.63446 0.336115 8.25567C0.11263 7.87688 0.000887871 7.45832 0.000887871 6.99999C0.000887871 6.53787 0.11263 6.11931 0.336115 5.74431C0.563388 5.36552 0.866418 5.06438 1.24521 4.8409C1.62399 4.61362 2.04255 4.49999 2.50089 4.49999C2.96301 4.49999 3.38157 4.61362 3.75657 4.8409C4.13536 5.06438 4.43649 5.36552 4.65998 5.74431C4.88725 6.11931 5.00089 6.53787 5.00089 6.99999C5.00089 7.45832 4.88725 7.87688 4.65998 8.25567C4.43649 8.63446 4.13536 8.93749 3.75657 9.16476C3.38157 9.38825 2.96301 9.49999 2.50089 9.49999ZM10.4384 9.49999C9.98005 9.49999 9.56149 9.38825 9.18271 9.16476C8.80392 8.93749 8.50089 8.63446 8.27362 8.25567C8.05013 7.87688 7.93839 7.45832 7.93839 6.99999C7.93839 6.53787 8.05013 6.11931 8.27362 5.74431C8.50089 5.36552 8.80392 5.06438 9.18271 4.8409C9.56149 4.61362 9.98005 4.49999 10.4384 4.49999C10.9005 4.49999 11.3191 4.61362 11.6941 4.8409C12.0729 5.06438 12.374 5.36552 12.5975 5.74431C12.8248 6.11931 12.9384 6.53787 12.9384 6.99999C12.9384 7.45832 12.8248 7.87688 12.5975 8.25567C12.374 8.63446 12.0729 8.93749 11.6941 9.16476C11.3191 9.38825 10.9005 9.49999 10.4384 9.49999ZM18.3759 9.49999C17.9176 9.49999 17.499 9.38825 17.1202 9.16476C16.7414 8.93749 16.4384 8.63446 16.2111 8.25567C15.9876 7.87688 15.8759 7.45832 15.8759 6.99999C15.8759 6.53787 15.9876 6.11931 16.2111 5.74431C16.4384 5.36552 16.7414 5.06438 17.1202 4.8409C17.499 4.61362 17.9176 4.49999 18.3759 4.49999C18.838 4.49999 19.2566 4.61362 19.6316 4.8409C20.0104 5.06438 20.3115 5.36552 20.535 5.74431C20.7623 6.11931 20.8759 6.53787 20.8759 6.99999C20.8759 7.45832 20.7623 7.87688 20.535 8.25567C20.3115 8.63446 20.0104 8.93749 19.6316 9.16476C19.2566 9.38825 18.838 9.49999 18.3759 9.49999ZM26.3134 9.49999C25.8551 9.49999 25.4365 9.38825 25.0577 9.16476C24.6789 8.93749 24.3759 8.63446 24.1486 8.25567C23.9251 7.87688 23.8134 7.45832 23.8134 6.99999C23.8134 6.53787 23.9251 6.11931 24.1486 5.74431C24.3759 5.36552 24.6789 5.06438 25.0577 4.8409C25.4365 4.61362 25.8551 4.49999 26.3134 4.49999C26.7755 4.49999 27.1941 4.61362 27.5691 4.8409C27.9479 5.06438 28.249 5.36552 28.4725 5.74431C28.6998 6.11931 28.8134 6.53787 28.8134 6.99999C28.8134 7.45832 28.6998 7.87688 28.4725 8.25567C28.249 8.63446 27.9479 8.93749 27.5691 9.16476C27.1941 9.38825 26.7755 9.49999 26.3134 9.49999ZM38.5435 11.7898C37.8579 11.7898 37.2443 11.6136 36.7026 11.2614C36.1609 10.9091 35.7329 10.3977 35.4185 9.72726C35.1041 9.05681 34.9469 8.24241 34.9469 7.28408C34.9469 6.31438 35.106 5.4962 35.4242 4.82953C35.7462 4.15908 36.1799 3.6534 36.7253 3.31249C37.2708 2.96779 37.8787 2.79544 38.5492 2.79544C39.0605 2.79544 39.481 2.88256 39.8105 3.05681C40.1401 3.22726 40.4015 3.4337 40.5946 3.67613C40.7878 3.91476 40.9374 4.14014 41.0435 4.35226H41.1287V-1.14441e-05H43.1912V11.6364H41.1685V10.2614H41.0435C40.9374 10.4735 40.784 10.6989 40.5833 10.9375C40.3825 11.1723 40.1174 11.3731 39.7878 11.5398C39.4583 11.7064 39.0435 11.7898 38.5435 11.7898ZM39.1174 10.1023C39.553 10.1023 39.9242 9.98484 40.231 9.74999C40.5378 9.51135 40.7708 9.17991 40.9299 8.75567C41.089 8.33143 41.1685 7.83711 41.1685 7.27272C41.1685 6.70832 41.089 6.21779 40.9299 5.80113C40.7746 5.38446 40.5435 5.06059 40.2367 4.82953C39.9337 4.59847 39.5605 4.48294 39.1174 4.48294C38.659 4.48294 38.2765 4.60226 37.9696 4.8409C37.6628 5.07953 37.4318 5.40908 37.2765 5.82953C37.1212 6.24999 37.0435 6.73105 37.0435 7.27272C37.0435 7.81817 37.1212 8.30491 37.2765 8.73294C37.4355 9.15719 37.6685 9.49241 37.9753 9.73863C38.2859 9.98105 38.6666 10.1023 39.1174 10.1023ZM38.8219 2.25567V0.954534H44.2651V2.25567H38.8219Z"
      fill="url(#paint0_linear_1617_5550)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1617_5550"
        x1="-1.4707"
        y1="6.21775"
        x2="44.5293"
        y2="6.20183"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0091AA" />
        <stop offset="1" stopColor="#57C785" />
      </linearGradient>
    </defs>
  </svg>
)
